import { createTheme } from '@mui/material/styles';

export const neonGreen = '#39FF14';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#00ff00',
      light: '#39ff14',
      dark: '#00cc00',
    },
    secondary: {
      main: '#1976d2',
      light: '#42a5f5',
      dark: '#1565c0',
    },
    background: {
      default: '#050505',
      paper: 'rgba(15, 15, 15, 0.8)',
    },
    text: {
      primary: '#ffffff',
      secondary: 'rgba(255, 255, 255, 0.7)',
    },
    success: {
      main: '#00ff00',
      light: '#39ff14',
      dark: '#00cc00',
    }
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h5: {
      fontWeight: 600,
      letterSpacing: '0.5px',
    },
    h6: {
      fontWeight: 500,
    },
    button: {
      fontWeight: 500,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'rgba(15, 15, 15, 0.8)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 0 10px rgba(0, 255, 0, 0.2)',
          borderBottom: '1px solid rgba(0, 255, 0, 0.2)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          background: 'rgba(15, 15, 15, 0.8)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 8px 32px rgba(0, 255, 0, 0.15)',
          border: '1px solid rgba(0, 255, 0, 0.2)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '8px',
        },
        containedPrimary: {
          boxShadow: '0 0 10px rgba(0, 255, 0, 0.3)',
          '&:hover': {
            boxShadow: '0 0 15px rgba(0, 255, 0, 0.5)',
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          minWidth: '120px',
          fontWeight: 500,
        },
      },
    },
  },
});
